import { render, staticRenderFns } from "./column_configuration.vue?vue&type=template&id=430a0e04&scoped=true&"
import script from "./column_configuration.vue?vue&type=script&lang=js&"
export * from "./column_configuration.vue?vue&type=script&lang=js&"
import style0 from "./column_configuration.vue?vue&type=style&index=0&id=430a0e04&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430a0e04",
  null
  
)

export default component.exports